import { createSlice } from "@reduxjs/toolkit";

const permissionDataSlice = createSlice({
  name: "permissionData",
  initialState: {
    user: null,
    userPermissionData: null,
  },

  reducers: {
    addUserPermissionData: (state, action) => {
      state.userPermissionData = action.payload;
    },
  },
});

export const { addUserPermissionData } = permissionDataSlice.actions;

export default permissionDataSlice.reducer;
